<!-- <main class="page-main"> -->
<div class="container-fluid layout layout--choose">
  <div class="layout__main">
    <h2 class="font-semibold mt-lg-30 mb-20">{{tiers?.length === 1 ? "Here's your plan" : pageInfo?.page_header}}</h2>

    <div class="plan-level mb-20" [attr.data-num-plans]="tiers?.length">
      <div class="plan-level__inner">
        <!-- hidden inputs with linked labels -->
        @for (tier of tiers; track tier; let i = $index) {
          <input type="radio" [attr.checked]="tier?.tier_id === selectedTier?.tier_id ? 'checked' : null"
            name="plan-levels" id="plan-level-{{tier?.tier_id}}"
            class="plan-level__input" />
        }

        <div class="plan-level__indi"></div>

        <div class="plan-level__items">
          @for (tier of tiers; track tier; let i = $index) {
            <label class="plan-level__item " (click)="setSelectedTier(tier)"
              [ngClass]="{'is-recommended': tier?.recommended === 1, 'is-active': tier?.tier_id === selectedTier?.tier_id}"
              for="plan-level-{{tier?.tier_id}}">
              <div class="plan-level__label">{{tier?.tier_name}}</div>
              <div class="plan-level__description">
                <small>{{tier?.tier_label}}</small>
              </div>
            </label>
          }

        </div>
      </div>
    </div>

    <p class="mb-40">{{selectedTier?.tier_refine_options}} <a href="#filters-modal"
      data-toggle="modal" data-backdrop="static"><strong>Tap here to refine your
    options</strong></a></p>

    <!-- Single product view when only 1 product -->
    @if (selectedProducts?.length === 1) {
      <div style="min-height: 600px;">
        @if (selectedProducts[0]; as product) {
          <div class="choose-single">
            <div class="choose-single__header">
              <div class="choose-single__header-company" (click)="openRatingSidesheet(product, $event)" style="cursor: pointer;">
                <div class="choose-single__header-company-thumb">
                  <img [src]="product?.img_path" class="img-fluid" [alt]="product?.product_name" />
                </div>
                <div class="choose-single__header-company-rating">
                  <div class="stars-compact">
                    <div class="stars-compact__star">
                      <svg class="icon">
                        <use xlink:href="#star"></use>
                      </svg>
                    </div>
                    <div class="stars-compact__num">{{ getOverallRating(product?.insurer_rating) || 5 }}</div>
                  </div>
                </div>
              </div>
              <div class="choose-single__header-title">
                <h5>{{product?.product_name}}</h5>
                @if (product?.exclusive === 1) {
                  <img src="/assets/icn/exclusive.svg" alt="Exclusive" class="icon">
                }
              </div>
              <div class="choose-single__header-price">
                <div class="choose-single__header-price-main"></div>
                <p class="price price--lg"><strong><em>{{product?.premium}}</em>.00</strong> /{{product?.frequency_short}}</p>
                @if (product?.addons_premium) {
                  <div class="choose-single__header-price-benefits">
                    <p><small>Including {{product?.addons_premium}} in <a href="#" (click)="openBenefitsSidesheet(product, $event)"
                      class="font-underline"><strong>added benefits</strong></a></small></p>
                    </div>
                  }
                  <div class="choose-single__header-price-breakdown">
                    <a href="#" (click)="openBreakdownSidesheet(product, $event)"><strong>See breakdown</strong></a>
                  </div>
                </div>
                <div class="choose-single__header-links">
                  <a href="javascript:void(0)" (click)="viewQuoteSchedule(product)">
                    <span>View quote schedule</span>
                    <svg class="icon icon--sm"><use xlink:href="#modal"></use></svg>
                  </a>
                  <a href="/pages/everything.docs-policy-wording-view.html" target="_blank">
                    <span>View product brochure</span>
                    <svg class="icon icon--sm"><use xlink:href="#brochure"></use></svg>
                  </a>
                  @if (product?.price_breakdown_document_id) {
                    <a href="javascript:void(0)" (click)="viewPricingBreakdown(product)">
                      <span>View pricing breakdown</span>
                      <svg class="icon icon--sm"><use xlink:href="#modal"></use></svg>
                    </a>
                  }
                </div>
              </div>
              <div class="choose-single__cta">
                <a href="#itk-modal" (click)="getQuoteITKs(product)" data-toggle="modal"
                class="button button--lg button--primary button--block-xs">Finalise and pay</a>
                <a href="javascript:void(0)" (click)="chat?.toggle()" class="button button--lg button--secondary button--block-xs">
                  <svg class="icon">
                    <use xlink:href="#mobile-call"></use>
                  </svg>
                  Chat to an agent
                </a>
              </div>
              <div class="choose-single__data">
                <div class="choose-single__features">
                  <h5 class="font-16 mb-10">Features</h5>
                  <ul class="list-unstyled">
                    @for (feature of product.features; track feature) {
                      <li>
                        <div class="choose-single__features-lhs">
                          <p>
                            {{feature?.label}}
                            @if (feature?.tooltip) {
                              <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                data-toggle="popover" data-trigger="focus"
                                [attr.data-content]="feature?.tooltip">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#info-solid"></use>
                                </svg>
                              </a>
                            }
                          </p>
                          @if (feature?.side_sheet_url) {
                            <a href="#" (click)="openExcessesSidesheet(product, $event)"
                              class="font-underline"><strong>Adjust excesses</strong></a>
                            }
                          </div>
                          @if (feature?.value) {
                            <div class="choose-single__features-rhs">
                              <p><small><strong>{{feature?.value}}</strong></small></p>
                            </div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                  <div class="choose-single__schedule">
                    <p>
                      <a href="javascript:void(0)" (click)="viewQuoteSchedule(product)">
                        <strong>View quote schedule</strong>
                        <svg class="icon">
                          <use xlink:href="#modal"></use>
                        </svg>
                      </a>
                    </p>
                  </div>
                  @if (product?.price_breakdown_document_id) {
                    <div class="choose-single__schedule">
                      <p>
                        <a href="javascript:void(0)" (click)="viewPricingBreakdown(product)">
                          <strong>View pricing breakdown</strong>
                          <svg class="icon">
                            <use xlink:href="#modal"></use>
                          </svg>
                        </a>
                      </p>
                    </div>
                  }
                  <div class="choose-single__benefits">
                    <h5 class="font-16 mb-10">Included in {{product?.product_name}}</h5>
                    <ul class="list-unstyled">
                      @for (benefit of product.benefits; track benefit) {
                        <li>
                          <div class="choose-single__benefits-icn">
                            <img class="icon icon--md" [src]="benefit?.img_path" alt="" />
                          </div>
                          <div class="choose-single__benefits-copy">
                            <div class="choose-single__benefits-lhs">
                              <p><small>{{benefit?.vaps_name}}</small></p>
                            </div>
                            @if (benefit?.limit) {
                              <div class="choose-single__benefits-rhs">
                                <p><small><strong>{{benefit?.limit}}</strong></small></p>
                              </div>
                            }
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
                <div class="choose-single__disclaimer">
                  <p><a href="/pages/everything.docs-policy-wording-view.html" target="_blank"><strong>View product brochure</strong></a></p>
                </div>
                <div class="choose-single__tray">
                  <div class="choose-single__tray-price">
                    <p class="price price--lg"><strong><em>{{product?.premium}}</em>.00</strong> /{{product?.frequency_short}}</p>
                    @if (product?.addons_premium) {
                      <div class="choose-single__tray-price-benefits">
                        <p><small>Including {{product?.addons_premium}} in <a href="#" (click)="openBenefitsSidesheet(product, $event)"
                          class="font-underline" tabindex="0"><strong>added benefits</strong></a></small></p>
                        </div>
                      }
                      <div class="choose-single__tray-price-breakdown">
                        <a href="#" (click)="openBreakdownSidesheet(product, $event)"><strong>See breakdown</strong></a>
                      </div>
                    </div>
                    <div class="choose-single__tray-cta">
                      <a href="javascript:void(0)" (click)="chat?.toggle()" class="button button--lg button--secondary">
                        <svg class="icon">
                          <use xlink:href="#mobile-call"></use>
                        </svg>
                      Chat to an agent</a>
                      <a href="#itk-modal" (click)="getQuoteITKs(product)" data-toggle="modal" class="button button--lg button--primary">
                      Finalise and pay</a>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          <!-- Slider view for multiple products -->
          @if (selectedProducts?.length > 1) {
            <div style="min-height: 900px;">
              <div class="choose-slider" id="choose-slider">
                @for (product of selectedProducts; track product; let i = $index) {
                  <div class="choose-slider__slide" [ngClass]="{'is-recommended': product?.recommended === 1}">
                    <div class="choose-slider__slide-inner">
                      <div class="choose-slider__content">
                        @if (product?.recommended === 1) {
                          <div class="choose-slider__note" id="demo-note">
                            <small>Recommended</small>
                          </div>
                        }
                        <div class="choose-slider__header">
                          <div class="choose-slider__header-company" (click)="openRatingSidesheet(product, $event)" style="cursor: pointer;">
                            <div class="choose-slider__header-company-thumb">
                              <img src="{{product?.img_path}}" class="img-fluid" alt="{{product?.product_name}}" />
                            </div>
                            <div class="choose-slider__header-company-rating">
                              <div class="stars-compact">
                                <div class="stars-compact__star">
                                  <svg class="icon">
                                    <use xlink:href="#star"></use>
                                  </svg>
                                </div>
                                <div class="stars-compact__num">{{ getOverallRating(product?.insurer_rating) || 0 }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="choose-slider__header-title">
                            <h5 id="demo-title-update">{{product?.product_name}}</h5>
                            @if (product?.exclusive === 1) {
                              <img src="/assets/icn/exclusive.svg" alt="Exclusive" class="icon">
                            }
                          </div>
                          <div class="choose-slider__header-price">
                            <div class="choose-slider__header-price-main"></div>
                            <p class="price price--lg" id="demo-price-update"><strong><em>{{product?.premium}}</em>.00</strong>
                          /{{product?.frequency_short}}</p>
                          @if (product?.addons_premium) {
                            <div class="choose-slider__header-price-benefits">
                              <p><small>Including {{product?.addons_premium}} in <a href="#" (click)="openBenefitsSidesheet(product, $event)"
                                class="font-underline"><strong>added
                              benefits</strong></a></small></p>
                            </div>
                          }
                          <div class="choose-slider__header-price-breakdown">
                            <a href="#" (click)="openBreakdownSidesheet(product, $event)"><strong>See breakdown</strong></a>
                          </div>
                        </div>
                      </div>
                      <div class="choose-slider__cta">
                        <a href="#itk-modal" (click)="getQuoteITKs(product)" data-toggle="modal"
                          class="button button--lg button--block-xs"
                          [ngClass]="{'button--primary': product?.recommended === 1, 'button--secondary': product?.recommended !== 1}">
                        {{product?.recommended === 1 ? 'Finalise and pay' : 'Choose and pay'}}</a>
                      </div>
                      <div class="choose-slider__features">
                        <h5 class="font-16 mb-10">Features</h5>
                        <ul class="list-unstyled">
                          @for (feature of product.features; track feature) {
                            <li>
                              <div class="choose-slider__features-lhs">
                                <p>
                                  {{feature?.label}}
                                  @if (feature?.tooltip) {
                                    <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                      data-toggle="popover" data-trigger="focus"
                                      [attr.data-content]="feature?.tooltip">
                                      <svg class="icon icon--sm">
                                        <use xlink:href="#info-solid"></use>
                                      </svg>
                                    </a>
                                  }
                                </p>
                                @if (feature?.side_sheet_url) {
                                  <a href="#" (click)="openExcessesSidesheet(product, $event)"
                                    class="font-underline" tabindex="-1"><strong>Adjust
                                  excesses</strong></a>
                                }
                              </div>
                              @if (feature?.value) {
                                <div class="choose-slider__features-rhs">
                                  <p><small><strong>{{feature?.value}}</strong></small></p>
                                </div>
                              }
                            </li>
                          }
                        </ul>
                      </div>
                    </div>
                    <div class="choose-slider__schedule">
                      <p>
                        <a href="javascript:void(0)" (click)="viewQuoteSchedule(product)">
                          <strong>View quote schedule</strong>
                          <svg class="icon">
                            <use xlink:href="#modal"></use>
                          </svg>
                        </a>
                      </p>
                    </div>
                    @if (product?.price_breakdown_document_id) {
                      <div class="choose-slider__schedule">
                        <p>
                          <a href="javascript:void(0)" (click)="viewPricingBreakdown(product)">
                            <strong>View pricing breakdown</strong>
                            <svg class="icon">
                              <use xlink:href="#modal"></use>
                            </svg>
                          </a>
                        </p>
                      </div>
                    }
                    <div class="choose-slider__btm">
                      <div class="choose-slider__benefits">
                        <h5 class="font-16 mb-10">Included in this product</h5>
                        <ul class="list-unstyled">
                          @for (benefit of product.benefits; track benefit) {
                            <li>
                              <div class="choose-slider__benefits-icn">
                                <img class="icon icon--md" src="{{benefit?.img_path}}" alt="" />
                              </div>
                              <div class="choose-slider__benefits-copy">
                                <div class="choose-slider__benefits-lhs">
                                  <p><small>{{benefit?.vaps_name}}</small></p>
                                </div>
                                <div class="choose-slider__benefits-rhs">
                                  <p><small><strong>{{benefit?.limit}}</strong></small></p>
                                </div>
                              </div>
                            </li>
                          }
                        </ul>
                      </div>
                      <div class="choose-slider__disclaimer">
                        <p><a href="/pages/everything.docs-policy-wording-view.html" target="_blank"><strong>View product
                        brochure</strong></a></p>
                        <!--
                        or modal - not sure how much data is in the policy wording
                        <p><a href="#demo-wording-modal" data-toggle="modal"><strong>View policy wording and summary</strong></a></p>
                        -->
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="row row--gap row--md mt-40 mb-20">
          <div class="col-xl-6">
            <div class="card card--help">
              <div class="card-body">
                <div class="card__thumb">
                  <img src="/assets/img/help-create-quote.svg" class="img-fluid" />
                </div>
                <div class="card__content">
                  <h5>Found a better deal?</h5>
                  <p>Share your quote or policy schedule from a different insurer and we’ll try our best to get you a
                  better price.</p>
                </div>
                <div class="card__btn">
                  <a href="#" class="button button--sm button--primary">Upload</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-6">
            <div class="card card--help">
              <div class="card-body">
                <div class="card__thumb">
                  <img src="/assets/img/help-chat-lady.svg" class="img-fluid" />
                </div>
                <div class="card__content">
                  <h5>Need help?</h5>
                  <p>Feel free to contact us via our online chatbot or call us directly if you would like help
                  completing your quote, or have any questions.</p>
                </div>
                <div class="card__btn">
                  <a href="javascript:void(0)" (click)="chat?.toggle()" class="button button--sm button--primary">Chat to us</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="layout__back">
        <button class="button button--back-alt d-md-none" title="Back" (click)="goBack()">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
        <button class="link d-none d-md-flex" (click)="goBack()">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
          <small>Back to summary</small>
        </button>
      </div>
    </div>
  <!-- </main> -->
  <div class="modal modal--mini fade" id="filters-modal" tabindex="-1" role="dialog" aria-labelledby="filters-modal"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-mini">

        <div class="modal-mini__heading">
          <div class="container-fluid">
            <h4><span class="font-normal">Refine what you’re looking for in </span> <strong>{{selectedTier?.tier_name}}</strong></h4>
            <button class="modal-mini__heading-close" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-mini__content">
          <div class="container-fluid">

            <div class="filter-group mb-10">

              @for (product of products; track product) {
                <label class="custom-input custom-input--checkbox custom-input--plan">
                  <input type="checkbox" (click)="setProduct(product)" name="checkbox-insurer-1" [checked]="isProductSelected(product)" />
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">
                    <span class="custom-input__label-company">
                      <img src="{{product?.img_path}}" alt="Santam" />
                    </span>
                    <span class="custom-input__label-text">
                      @if (product?.recommended === 1) {
                        <span class="tag-pill  tag-pill--everything-bg">
                          Recommended
                        </span>
                      }
                      <p>{{product?.product_name}}</p>
                    </span>
                    <span class="custom-input__label-price">
                      <p class="price price--sm"><strong>{{product?.premium}}</strong>/mo</p>
                    </span>
                  </span>
                </label>
              }

            </div>

          </div>
        </div>

        <div class="modal-mini__button">
          <div class="container-fluid">
            <a href="#" data-dismiss="modal" class="button button--block button--primary"
            id="filter-products-submit"  [class.disabled]="!filterTouched" [attr.disabled]="!filterTouched ? true : null">Show options</a>
          </div>
        </div>


      </div>
    </div>
  </div>
  <!-- Benefits Sidesheet Component -->
  <app-sidesheet
    #benefitsSidesheet
    sidesheetId="benefits-sidesheet"
    title="Added benefits"
    type="benefits"
    [data]="addedBenefits"
    [showBackButton]="true"
    [showEditButton]="true"
    [showTray]="true"
    [trayTotal]="selectedProduct?.premium"
    (closed)="onBenefitsSidesheetClosed()"
    (itemSelected)="onBenefitItemSelected($event)">
  </app-sidesheet>

  <!-- Breakdown Sidesheet Component -->
  <app-sidesheet
    #breakdownSidesheet
    sidesheetId="breakdown-sidesheet"
    type="insured-items"
    [data]="breakdownData"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    [trayTotal]="selectedProduct?.premium"
    (closed)="onBreakdownSidesheetClosed()">
  </app-sidesheet>

  <!-- Company Ratings Sidesheet Component -->
  <app-sidesheet
    #ratingSidesheet
    sidesheetId="company-ratings-sidesheet"
    [title]="selectedProduct?.product_name || 'Company Rating'"
    type="rating"
    [ratingData]="selectedProduct?.insurer_rating"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    (closed)="onRatingSidesheetClosed()">
  </app-sidesheet>

  <!-- Excesses Sidesheet Component -->
  <app-sidesheet
    #excessesSidesheet
    sidesheetId="excesses-sidesheet"
    [title]="'Excesses for ' + (selectedProduct?.product_name || '')"
    type="excesses"
    [data]="excessesData"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    [trayTotal]="selectedProduct?.premium"
    (closed)="onExcessesSidesheetClosed()"
    (excessChanged)="onExcessValueChanged($event)">
  </app-sidesheet>

  <!-- Important Things to Know Modal -->
  <div class="modal fade modal--mini" id="itk-modal" tabindex="-1" role="dialog" aria-labelledby="itk-modal"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-mini">
        <div class="modal-mini__heading">
          <div class="container-fluid">
            <h4>Important things to know</h4>
          </div>
        </div>

        <div class="modal-mini__content">
          <div class="container-fluid">
            <!-- can use accordion--sm modifier for smaller copy within the content area -->
            <div class="accordion accordion--gethelp" id="accordion-faqs">
              <div class="accordion__item">
                <a href="#faq-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                  <div class="accordion__title-text">
                    <h5>Sub-limits</h5>
                  </div>
                  <div class="accordion__title-caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="accordion__body collapse" id="faq-1" data-parent="#accordion-faqs">
                  <div class="accordion__content">
                    @for (subLimit of quoteITKs?.sub_limits; track subLimit) {
                      <p [innerHTML]="subLimit?.sublimit_name">
                      </p>
                      <p [innerHTML]="subLimit?.sublimit_description">
                      </p>
                      <p [innerHTML]="subLimit?.sublimit_value">
                      </p>
                    }
                  </div>
                </div>
              </div>
              <!-- /.accordion__item -->

              <div class="accordion__item">
                <a href="#faq-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                  <div class="accordion__title-text">
                    <h5>What's covered and what's not</h5>
                  </div>
                  <div class="accordion__title-caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="accordion__body collapse" id="faq-2" data-parent="#accordion-faqs">
                  <div class="accordion__content">
                    <p>

                    </p>
                    <ul>
                      @for (cover of quoteITKs?.cover; track cover) {
                        <li >
                          <strong>{{cover?.cover_name}}</strong><br>
                          {{cover?.cover_description}} - {{cover?.cover_value}}
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /.accordion__item -->

              <div class="accordion__item">
                <a href="#faq-3" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                  <div class="accordion__title-text">
                    <h5>Excesses</h5>
                  </div>
                  <div class="accordion__title-caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="accordion__body collapse" id="faq-3" data-parent="#accordion-faqs">
                  <div class="accordion__content">
                    <p>

                    </p>
                    @for (group of quoteITKs?.excess; track group) {
                      <h6>{{group.class_name}}</h6>
                      <ul>
                        @for (excess of group.items; track excess) {
                          <li>
                            <strong>{{excess?.description}}</strong> - {{excess?.excess}}
                          </li>
                        }
                      </ul>
                    }
                  </div>
                </div>
              </div>
              <!-- /.accordion__item -->
            </div>
          </div>
        </div>

        <div class="modal-mini__button">
          <div class="container-fluid">
            <a href="#" data-dismiss="modal" (click)="onContinue()" class="button button--primary">Continue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /modal -->
